import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-fleet-board-modal',
  templateUrl: './fleet-board-modal.component.html',
  styleUrls: ['./fleet-board-modal.component.scss'],
})
export class FleetBoardModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<FleetBoardModalComponent>,
    private api: UserApiService
  ) {}

  ngOnInit(): void {
    this.getAnnouncement();
  }

  close() {
    this.dialogRef.close();
    this.confirmDialog();
  }

  loading = false;
  data: any = {};
  async getAnnouncement() {
    try {
      this.loading = true;
      const r = await this.api.getAnnouncement();
      this.data = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  async confirmDialog() {
    try {
      const r = await this.api.confirmDialog(true);
    } catch (error) {}
  }
}
